<div class="wrapper">
  <svg class="svg" [attr.transform]="'translate(0, 0)'" [attr.width]="canvas.width" [attr.height]="canvas.height">
    <!--
      AXES
    -->

    <g class="axes" *ngIf="actualData">
      <!-- AXIS Y (value axis)-->
      <g
        class="axis-y axis"
        [attr.transform]="
          showYAxis
            ? 'translate(' + (canvas.margin.left - canvas.padding.left) + ',' + 0 + ')'
            : 'translate(' + canvas.padding.left + ',' + 0 + ')'
        "
      >
        <g *ngFor="let axis of axesY; let i = index" class="axis" [attr.transform]="'translate(' + 0 + ',' + axis.coord + ')'">
          <line
            class="tick"
            [attr.x1]="0"
            [attr.y1]="0"
            [attr.x2]="canvas.width - (canvas.margin.left - canvas.padding.left) - (canvas.margin.right - canvas.padding.right)"
            [attr.y2]="0"
          />
          <text *ngIf="actualData.length > 0 && showYAxis" class="axis-text label-xs" text-anchor="end" x="0" y="0" dy="3" dx="-5">
            {{ axis.label | formatNumber }}
          </text>
        </g>
        <line
          class="tick line-x"
          [attr.x1]="0"
          [attr.y1]="canvas.height - canvas.margin.bottom"
          [attr.x2]="canvas.width - (canvas.margin.left - canvas.padding.left) - (canvas.margin.right - canvas.padding.right)"
          [attr.y2]="canvas.height - canvas.margin.bottom"
        />
      </g>

      <!-- AXIS X (Time axis)-->
      <g
        *ngIf="actualData.length > 0"
        class="axis-x axis"
        [attr.transform]="'translate(' + 0 + ',' + (canvas.height - canvas.margin.bottom) + ')'"
      >
        <g *ngFor="let axis of axesX; let i = index" class="axis" [attr.transform]="'translate(' + axis.coord + ',' + 0 + ')'">
          <line class="tick" [attr.x1]="0" [attr.y1]="0" [attr.x2]="0" [attr.y2]="axis.size" />
          <text class="axis-text label-xs" text-anchor="middle" x="0" y="15" dy="2">{{ axis.label }}</text>
        </g>
      </g>
    </g>

    <!-- RANGE SELECTOR -->
    <g
      *ngIf="canvas"
      chart-timeline-range-selector
      [unitTime]="unitTime"
      [canvas]="canvas"
      [dateRange]="timeRange"
      [(rangeSelectModel)]="rangeSelection"
      (rangeSelectModelChange)="rangeSelectModelChangeRANGE($event)"
    ></g>

    <!-- LINES CHART -->
    <g
      class="chart-lines"
      chart-line
      (animationChange)="lineAnimationChanged($event)"
      [canvas]="canvas"
      [chartData]="chartData"
      [dataRange]="dataRange"
      [timeRange]="timeRange"
      [canvasHorizontalRange]="canvasHorizontalRange"
      [canvasVerticalRange]="canvasVerticalRange"
    ></g>

    <!-- DATE POINTS INTERACTIVE UI -->
    <g class="data-points">
      <g *ngFor="let line of dataPoints" class="data-point">
        <g *ngFor="let point of line" (mouseenter)="mouseenter($event, point)" (mouseleave)="mouseleave()">
          <circle
            class="data-point-circle"
            cx="0"
            r="4"
            [attr.cy]="point.y"
            [attr.cx]="point.x"
            [attr.fill]="colorCategoryMap[point.category]"
          />
        </g>
      </g>

      <!-- Gradients for key events duration -->
      <g [id]="gradientWrapperId">
        <defs>
          <linearGradient [id]="linerGradientId" gradientUnits="userSpaceOnUse" x1="50.89%" y1="-0.86%" x2="49.11%" y2="100.86%">
            <stop [attr.stop-color]="linearGradientStopColor" />
            <stop offset="1.079" [attr.stop-color]="linearGradientStopColor" stop-opacity=".00" />
          </linearGradient>
        </defs>

        <path
          *ngIf="clickedKeyEventClassName"
          [attr.d]="storedKeyEventPath[selectedKeyEvent?.uri]"
          [attr.fill]="'url(#' + linerGradientId + ')'"
        ></path>
      </g>

      <g
        #keyEvent
        [class.selected-key-event]="keyEventClassNamePrefix + point.uri === clickedKeyEventClassName"
        [class.hidden]="hoveredKeyEvent"
        [class]="keyEventClassName"
        *ngFor="let point of mappedKeyEventsData"
      >
        <!-- dash-line -->
        <line
          class="key-events-dash-line-tick {{ keyEventClassNamePrefix + point.uri }}"
          [class.highlight]="keyEventClassNamePrefix + point.uri === clickedKeyEventClassName"
          [attr.x1]="point?.x"
          [attr.y1]="point?.y"
          [attr.x2]="point?.x"
          [attr.y2]="point?.y + canvas.height - canvas.margin.bottom - point?.y"
        ></line>

        <!-- dash-line-top-circle -->
        <circle
          class="key-events-dash-line-circle"
          [class.visible]="keyEventClassNamePrefix + point.uri === clickedKeyEventClassName"
          cx="0"
          [attr.r]="dashLineTopCircle"
          [attr.cy]="point?.y + dashLineTopCircle"
          [attr.cx]="point?.x"
        />

        <!-- circle with signals icon -->
        <circle
          #circle
          class="{{ keyEventSignalIconCircleClassName }} {{ keyEventClassNamePrefix + point.uri }}"
          [class.highlight]="keyEventClassNamePrefix + point.uri === clickedKeyEventClassName"
          (mouseover)="onKeyEventMouseOver(point)"
          cx="0"
          [attr.r]="circleRadius"
          [attr.cy]="point?.y + canvas.height - canvas.margin.bottom - point?.y"
          [attr.cx]="point?.x"
        />

        <!-- bell icon on circle -->
        <text
          [attr.dx]="point?.x"
          [attr.dy]="point?.y + canvas.height - canvas.margin.bottom - point?.y + circleRadius / 2"
          class="key-events-signals-icon"
          [attr.text-anchor]="'middle'"
        >
          
        </text>
      </g>

      <!-- Dummy create event when hovered -->
      <g *ngIf="hoveredKeyEvent">
        <line
          class="key-events-dash-line-tick {{ keyEventClassNamePrefix + hoveredKeyEvent.keyEvent.uri }}"
          [class.highlight]="keyEventClassNamePrefix + hoveredKeyEvent.keyEvent.uri === clickedKeyEventClassName"
          [attr.x1]="hoveredKeyEvent.keyEvent?.x"
          [attr.y1]="hoveredKeyEvent.keyEvent?.y"
          [attr.x2]="hoveredKeyEvent.keyEvent?.x"
          [attr.y2]="hoveredKeyEvent.keyEvent?.y + canvas.height - canvas.margin.bottom - hoveredKeyEvent.keyEvent?.y"
        ></line>

        <!-- dash-line-top-circle -->
        <circle
          class="key-events-dash-line-circle"
          [class.visible]="keyEventClassNamePrefix + hoveredKeyEvent.keyEvent.uri === clickedKeyEventClassName"
          cx="0"
          [attr.r]="dashLineTopCircle"
          [attr.cy]="hoveredKeyEvent.keyEvent?.y + dashLineTopCircle"
          [attr.cx]="hoveredKeyEvent.keyEvent?.x"
        />

        <!-- circle with signals icon -->
        <circle
          #circle
          (click)="onKeyEventClicked(hoveredKeyEvent.keyEvent)"
          (mouseout)="onKeyEventMouseOut()"
          class="{{ keyEventSignalIconCircleClassName }} {{ keyEventClassNamePrefix + hoveredKeyEvent.keyEvent.uri }}"
          [class.highlight]="keyEventClassNamePrefix + hoveredKeyEvent.keyEvent.uri === clickedKeyEventClassName"
          cx="0"
          [attr.r]="circleRadius"
          [attr.cy]="hoveredKeyEvent.keyEvent?.y + canvas.height - canvas.margin.bottom - hoveredKeyEvent.keyEvent?.y"
          [attr.cx]="hoveredKeyEvent.keyEvent?.x"
        />

        <!-- bell icon on circle -->
        <text
          [attr.dx]="hoveredKeyEvent.keyEvent?.x"
          [attr.dy]="hoveredKeyEvent.keyEvent?.y + canvas.height - canvas.margin.bottom - hoveredKeyEvent.keyEvent?.y + circleRadius / 2"
          class="key-events-signals-icon"
          [attr.text-anchor]="'middle'"
        >
          
        </text>
      </g>
    </g>
  </svg>

  <!-- Tainted data warning -->
  <ng-container *ngFor="let dataPoint of dataPoints">
    <ng-container *ngFor="let point of dataPoint.pointsCoordY; let ind = index">
      <div
        [ngStyle]="{
          transform: 'translate(' + dataPoint.coordX + 'px,' + point + 'px) translate(-50%, -5px)'
        }"
        *ngIf="dataPoint.data[ind].tainted"
        class="icon-alert warning"
        title="This information is not accurate."
        [ngClass]="{ animate: animate }"
      ></div>
    </ng-container>
  </ng-container>

  <!-- CATEGORIES -->
  <div *ngIf="showLegend" class="categories mt-6">
    <div class="category" *ngFor="let category of categories">
      <div class="circle-category" [ngStyle]="{ background: colorCategoryMap[category.id] }"></div>
      <div class="label-xs">
        {{ category.label | titleCase }}
      </div>
    </div>
    <div class="category series-limit-message" *ngIf="seriesLimitMessage">
      <div class="label-xs">
        {{ seriesLimitMessage }}
      </div>
    </div>
  </div>
</div>

<!-- TOOLTIP -->
<div
  *ngIf="tooltip"
  class="tooltip"
  [ngStyle]="{
    transform: tooltip.position
  }"
>
  <div class="tooltip-date label-sm mb-3">
    {{ tooltip.date }}
  </div>

  <div class="tooltip-point">
    <div class="tooltip-label-category label-sm">
      {{ tooltip.label | titleCase }}
    </div>

    <div class="tooltip-point-data label-sm-semibold pl-2">
      {{ tooltip.value | formatNumber }}
      <span *ngIf="tooltip.tainted" class="icon-alert"></span>
    </div>
  </div>
</div>

<!-- key events tooltip -->
<div
  *ngIf="keyEventTooltip"
  [ngStyle]="{
    transform: keyEventTooltip?.position
  }"
  class="key-event-tooltip-wrapper"
>
  <div class="wrapper flex flex-row label-sm-semibold-single mb-2">
    <div class="rate flex items-center" [class]="keyEventTooltip?.data?.isGrowth ? 'signals-growth' : 'signals-decline'">
      <i class="icon icon2-x16-down"></i>
      <span *ngIf="keyEventTooltip?.data?.growthRate > 0">{{ keyEventTooltip?.data?.growthRate | number: '1.0-2' }}%</span>
    </div>
    <span class="type"
      ><strong class="label-sm-semibold-single">{{ keyEventTooltip?.data?.docType | uppercase }}</strong></span
    >
  </div>

  <div class="date-wrapper flex label-xs-single">
    <span class="from-text">from</span>
    <span class="start-end-date"
      >{{ keyEventTooltip?.data?.startDate | date: 'mediumDate' }} - {{ keyEventTooltip?.data?.endDate | date: 'mediumDate' }}</span
    >
  </div>
</div>

<!-- NO DATA TO SHOW -->
<div *ngIf="noData" class="placeholder-no-input-data" [ngClass]="{ 'white-BG': isNormalizeProcessStillRunning }">
  <!-- no data for the selected timeframe -->
  <div *ngIf="noDataTimeframe && !loading" class="no-data-hint">
    <span class="label-xs main-gray-light"> {{ 'chart-ng.timeline.emptyState.noDataTimeframe' | translate }} </span>
  </div>

  <!-- loading state when normalize data process is still running-->
  <div class="loading-state" *ngIf="isNormalizeProcessStillRunning">
    <ui2-empty-state>
      <img src="assets/img/foresight/empty-timeline.jpg" alt="empty-timeline" class="empty-timeline-img" />
      <div class="loading-state-label">
        <div class="label-base-single main-gray-light pb-2">{{ 'chart-ng.timeline.emptyState.processingData' | translate }}</div>
        @if (!isOldElement) {
          <div class="label-xs main-gray-light">
            <span> {{ 'chart-ng.timeline.emptyState.descriptionPrefix' | translate }} </span>
            <strong>{{ 'chart-ng.timeline.emptyState.descriptionSuffix' | translate }}</strong>
          </div>
        } @else {
          <div class="label-xs main-gray-light normalization-in-progress-section">
            <div class="label-xs main-gray-light">
              <span> {{ 'chart-ng.timeline.emptyState.descriptionPendingNormalization' | translate }} </span>
            </div>
            <div class="label-xs primary-color mt-4">
              <strong>
                <!-- I can't use the GoItonicsIoLink enum here as it causes a circular dependecy... -->
                <a class="link" [href]="'https://go.itonics.io/sig-hlp'" target="_blank">{{
                  'chart-ng.timeline.emptyState.pendingNormalizationLink' | translate
                }}</a>
              </strong>
            </div>
          </div>
        }
      </div>
    </ui2-empty-state>
  </div>
</div>

<!-- Data Loader in timeline -->
<div *ngIf="loading" class="data-loader mt-4">
  <ui-loader></ui-loader>
</div>
